const FakeForm = () => {
  return (
    <form
      id="FakeForm"
      action="/autodebit/apluspay"
      method="POST"
      style={{ display: "none" }}
      acceptCharset="shift_jis"
    >
      <input type="text" name="kfrequest" id="kfrequest" />
      <input type="submit" value="Submit request" />
    </form>
  );
};

export default FakeForm;
